// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"401":"70d223dd","973":"f9f50782"}[chunkId] + ".css";
};